import React from 'react';
import { Link } from 'react-router-dom';


const GnbLayoutComponent = props => {
    const { menuIdx, toggleMobileGnb, isOnShowMobileGnb,
        onClickBtnContact, onClickBtnCloseMobileGnb,
        onClickBtnAbout, onClickBtnStyleAndFabric,
        onClickBtnStoriesAndNews, onClickBtnNewMaterialAndProduction } = props;
    // console.log('match', match);

    return (
        <header className={`${isOnShowMobileGnb ? "on" : ""}`}>
            <button class="mb btn-close-modal black"
                onClick={onClickBtnCloseMobileGnb}><i></i></button>
            {/* Mobile */}
            <nav id='gnb-mb'>
                <div class="logo"><i></i></div>
                <button
                    onClick={evt => toggleMobileGnb(false)}
                    class="btn-close-modal black">
                    <i></i>
                </button>
                <ul>
                    <li class={`menu about ${menuIdx === 1 ? 'on' : ''}`}>
                        <div class="top-line"></div>
                        <a class="text" onClick={onClickBtnAbout}>ABOUT TCE</a>
                        <div class="submenu">
                            <ul>
                                <li><Link class="text" to="/about/introduction" onClick={evt => toggleMobileGnb(false)}>INTRODUCTION</Link></li>
                                <li><Link class="text" to="/about/sustainability" onClick={evt => toggleMobileGnb(false)}>SUSTAINABILITY</Link></li>
                                <li><Link class="text" to="/about/production" onClick={evt => toggleMobileGnb(false)}>PRODUCTION</Link></li>
                            </ul>
                            <div class="bottom"></div>
                        </div>
                    </li>
                    <li class={`menu style-fabric ${menuIdx === 2 ? 'on' : ''}`}>
                        <div class="top-line"></div>
                        <a class="text" onClick={onClickBtnStyleAndFabric}>STYLE &amp; FABRIC</a>
                        <div class="submenu">
                            <ul>
                                <li>
                                    <a
                                        onClick={evt => props.onClickGnbFabricStyle('MEN')}
                                        className='text'>MEN's</a>
                                </li>
                                <li>
                                    <a
                                        onClick={evt => props.onClickGnbFabricStyle('WOMEN')}
                                        className='text'>WOMEN's</a>
                                </li>
                                <li>
                                    <a
                                        onClick={evt => props.onClickGnbFabricStyle('ACC')}
                                        className='text'>ACCESSORIES</a>
                                </li>
                            </ul>
                            <div class="bottom"></div>
                        </div>
                    </li>
                    <li class={`menu stories-news ${menuIdx === 3 ? 'on' : ''}`}>
                        <div class="top-line"></div>
                        <a class="text" onClick={onClickBtnStoriesAndNews}>STORIES &amp; NEWS</a>
                        <div class="submenu">
                            <div class="bottom"></div>
                        </div>
                    </li>
                    <li class={`menu news-material-production ${menuIdx === 4 ? 'on' : ''}`}>
                        <div class="top-line"></div>
                        <a class="text" onClick={onClickBtnNewMaterialAndProduction}>NEW MATERIAL &amp;
                                PRODUCTION</a>
                        <div class="submenu">
                            <div class="bottom"></div>
                        </div>
                    </li>
                </ul>
                <div class='footer'>
                    <a class='contact' href="#"
                        onClick={onClickBtnContact}>CONTACT</a>
                    <hr />
                    <ul class="sns">
                        <li><a class="home" href="http://www.tcedenim.com/"
                            rel="noopener noreferrer" target="_blank"><i></i></a></li>
                        <li><a class="facebook" href="https://www.facebook.com/TCEdenimstory/"
                            rel="noopener noreferrer" target="_blank"><i></i></a></li>
                        <li><a class="youtube" href="https://www.youtube.com/channel/UCXpRK4O2lJ9XaG9c-uQccPg"
                            rel="noopener noreferrer" target="_blank"><i></i></a></li>
                    </ul>
                    <div class="etc">
                        <div class="copyright">Copyright ©TCE. All rights reserved.</div>
                    </div>
                </div>
            </nav>

            {/* PC */}
            <nav id='gnb'>
                <ul>
                    <li className={`menu about ${menuIdx === 1 ? 'on' : ''}`}>
                        <div className='top-line'></div>
                        <Link
                            className='text'
                            to='/about/introduction'>ABOUT TCE</Link>
                        <div className='bottom-lines'>
                            <div className='top'></div>
                            <ul className='submenu'>
                                <li>
                                    <Link
                                        className='text'
                                        to='/about/introduction'>INTRODUCTION</Link>
                                </li>
                                <li>
                                    <Link
                                        className='text'
                                        to='/about/sustainability'>SUSTAINABILITY</Link>
                                </li>
                                <li>
                                    <Link className='text'
                                        to='/about/production'>PRODUCTION</Link>
                                </li>
                            </ul>
                            <div className='bottom'></div>
                        </div>
                    </li>
                    <li className="divider">
                        <i className="icon circle-divider"></i>
                    </li>

                    <li className={`menu style-fabric ${menuIdx === 2 ? 'on' : ''}`}>
                        <div className='top-line'></div>
                        <Link
                            className='text'
                            onClick={evt => props.onClickGnbFabricStyle()}
                        >STYLE & FABRIC</Link>
                        <div className='bottom-lines'>
                            <div className='top'></div>
                            <ul className='submenu'>
                                <li>
                                    <a
                                        onClick={evt => props.onClickGnbFabricStyle('MEN')}
                                        className='text'>MEN's</a>
                                </li>
                                <li>
                                    <a
                                        onClick={evt => props.onClickGnbFabricStyle('WOMEN')}
                                        className='text'>WOMEN's</a>
                                </li>
                                <li>
                                    <a
                                        onClick={evt => props.onClickGnbFabricStyle('ACC')}
                                        className='text'>ACCESSORIES</a>
                                </li>
                            </ul>
                            <div className='bottom'></div>
                        </div>
                    </li>
                    <li className="divider">
                        <i className="icon circle-divider"></i>
                    </li>

                    <li className={`menu stories-news ${menuIdx === 3 ? 'on' : ''}`}>
                        <div className='top-line'></div>
                        <Link
                            className='text'
                            to='/stories-news'>STORIES & NEWS</Link>
                        <div className='bottom-lines'>
                            <div className='top'></div>
                            <div className='bottom'></div>
                        </div>
                    </li>
                    <li className="divider">
                        <i className="icon circle-divider"></i>
                    </li>
                    <li className={`menu news-material-production ${menuIdx === 4 ? 'on' : ''}`}>
                        <div className='top-line'></div>
                        <Link
                            className='text'
                            to='/new-material-production'>NEW MATERIAL & PRODUCTION</Link>
                        <div className='bottom-lines'>
                            <div className='top'></div>
                            <div className='bottom'></div>
                        </div>
                    </li>
                </ul>
            </nav>
        </header>
    )
}

export default GnbLayoutComponent;